
import {Links, UserDto, ViewProcessCommentDto} from '../services/generated';
import {ProcessMinimum} from './ProcessMinimum';

export class ProcessCommentManage implements ViewProcessCommentDto {
  public id: number;
  public link: Links[] | null;
  public created: string;
  public comment: string | null;
  public createdBy: UserDto | null;
  public process: ProcessMinimum;
  public processOwner: UserDto | null;
  public status: string | null;
  public isMain: boolean = false;
  public resolved: boolean = false;
  public canDeletedByMe: boolean = false;


  constructor(comment: ViewProcessCommentDto) {
    this.id = comment.id;
    this.link = comment.link;
    this.created = comment.created;
    this.comment = comment.comment;
    this.createdBy = comment.createdBy;
    this.process = new ProcessMinimum(comment.process);
    this.processOwner = comment.processOwner;
    this.status = comment.status;
    this.isMain = comment.isMain;
    this.resolved = comment.resolved;
    this.canDeletedByMe = comment.canDeletedByMe;
  }
}
